
    <fieldmagic-dialog
      label="Resolution Details"
      icon="file-alt"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <table class="table table-bordered">
          <thead>
            <tr>
              <td
                width="30%"
              >
                <fieldmagic-text
                  content="Resolution Notes"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>

              <td
                width="30%"
              >
                <fieldmagic-text
                  content="Resolved By"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>

              <td
                width="30%"
              >
                <fieldmagic-text
                  content="Date Resolved"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
            </tr>
          </thead>

          <tbody *ngIf="fault$ | async as fault">
            <td>
              {{ fault.resolution_notes | placeholdWithString }}
            </td>

            <td>
              {{ fault.resolved_by_text }}
            </td>

            <td>
              {{ fault.date_resolved | format: 'll' }}
            </td>
          </tbody>
        </table>
      </ng-template>
    </fieldmagic-dialog>
  